import { SUBTENANT_DATA } from "../actionType";

export const subTenantDataRequest = (data: any) => ({
    type: SUBTENANT_DATA.LOAD,
    payload: data
})